import type {
	OnDialogDisplay,
	OnIssueCountFetched,
	OnSuccessful,
	OnFail,
	OnDialogCancel,
} from '../../model/index.tsx';
import type { State } from '../types.tsx';

export const onIssueCountFetched = (state: State): OnIssueCountFetched =>
	state.callbacks.onIssueCountFetched;

export const onSuccessful = (state: State): OnSuccessful => state.callbacks.onSuccessful;

export const onFail = (state: State): OnFail => state.callbacks.onFail;

export const onDialogDisplay = (state: State): OnDialogDisplay => state.callbacks.onDialogDisplay;

export const onDialogCancel = (state: State): OnDialogCancel => state.callbacks.onDialogCancel;
